import Checkbox from './Checkbox/Checkbox';
import Ranges from './Ranges/Ranges';
import Slider from './Slider/Slider';

export default {
  term: Checkbox,
  range: Ranges,
  slider: Slider,
};
